<div class="modal-content text-center">
    <div class="modal-header text-center">
        <button type="button" class="btn-close" (click)="cerrar()"></button>
    </div>
    <div class="modal-body pb-5">
        <!-- <h3 class="mt-2">{{escritorio.ejecutivo}}</h3> -->
        <h3 class="">Registro para Llamado Paciente</h3>
        <!-- <h6>Ingrese el RUT del cliente</h6> -->
    </div>
    <div class="modal-footer">
        <form [formGroup]="form" *ngIf="form" (ngSubmit)="onSubmit()">
                <div class="row  mx-auto text-center">
                <div class="col-xl-12">
                    <label class="pe-2">
                        <input type="radio" formControlName="docType" value="rut" (change)="setType()"> RUT
                    </label>
                    <label>
                        <input type="radio" formControlName="docType" value="dni" (change)="setType()"> DNI
                    </label>
                </div>
                <div class="col-xl-6 col-12 mb-4">
                    <div class="input-group">
                        <input type="text" id="name" formControlName="name" class="form-control" placeholder="Nombre paciente">
                    </div>
                    <div *ngIf="submitted && form.get('name')!.errors">
                        <div>
                            <small class="text-danger" *ngIf="form.get('name')?.hasError('required')">Debe ingresar un nombre.</small>
                            <small class="text-danger" *ngIf="form.get('name')?.hasError('minlength') || form.get('name')?.hasError('pattern')">Debe ingresar un nombre válido.</small>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-12 mb-4">
                    <div class="input-group">
                        <input type="text" id="lastname" formControlName="lastname" class="form-control" placeholder="Apellido paciente">
                    </div>
                    <div *ngIf="submitted && form.get('name')!.errors">
                        <div>
                            <small class="text-danger" *ngIf="form.get('lastname')?.hasError('required')">Debe ingresar un apellido.</small>
                            <small class="text-danger" *ngIf="form.get('lastname')?.hasError('minlength') || form.get('name')?.hasError('pattern')">Debe ingresar un apellido válido.</small>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-12 mb-4">
                    <div class="input-group">
                        <input type="text" formControlName="rut" class="form-control" [placeholder]="form.get('docType')?.value == 'rut' ? 'RUT paciente' : 'DNI paciente'" (keyup)="formatRut()" [maxLength]="form.get('docType')?.value === 'rut' ? 12 : 8">
                    </div>
                    <div *ngIf="submitted && form.get('rut')!.errors">
                        <div>
                            <small class="text-danger" *ngIf="form.get('rut')?.hasError('required')">{{form.get('docType')?.value === 'rut' ? 'Debe ingresar un RUT.' : 'Debe ingresar un DNI.'}}</small>
                            <small class="text-danger" *ngIf="form.get('rut')?.hasError('rutInvalid')">Debe ingresar un RUT válido.</small>
                            <small class="text-danger" *ngIf="form.get('rut')?.hasError('pattern')">Debe ingresar un DNI válido.</small>
                            
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-12 mb-4">
                    <div class="input-group">
                        <input type="text" formControlName="phone" class="form-control" placeholder="Celular paciente sin +56 (opcional)">
                    </div>
                    <div *ngIf="submitted && form.get('phone')!.errors">
                        <div>
                            <small class="text-danger">Debe ingresar un celular válido.</small>
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-4">
                    <div class="input-group">
                        <input type="email" formControlName="email" class="form-control" placeholder="e-mail paciente (opcional)">
                    </div>
                    <div *ngIf="submitted && form.get('email')!.errors">
                        <div>
                            <small class="text-danger">Debe ingresar un e-mail válido.</small>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="col-xl-6 col-12 mb-4">
                    <div class="input-group">
                        <select formControlName="office" (change)="filterEsp()">
                          <option value="" disabled>Seleccione oficina</option>
                          <option *ngFor="let office of offices" [ngValue]="office.idoficina">{{office.oficina}}</option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.get('office')!.errors">
                        <div>
                            <small class="text-danger">Debe seleccionar una oficina.</small>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-12 mb-4">
                    <div class="input-group">
                        <select formControlName="esp">
                            <option value="" disabled>Seleccione especialista (opcional)</option>
                            <option *ngFor="let esp of esps" [value]="esp.idEsp">    
                                {{ esp.nombre }} ({{ esp.estado == 'A' ? 'Conectado' : 'Desconectado' }})
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-xl-6 col-12 mb-4">
                    <div class="input-group">
                        <input type="date" formControlName="date" class="form-control">
                    </div>
                </div>

                <div class="col-xl-6 col-12 mb-4">
                    <div class="input-group">
                        <select formControlName="hour">
                            <option value="" disabled>Seleccione hora agenda (opcional)</option>
                            <option *ngFor="let hour of hours" [value]="hour">    
                                {{hour}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-12 mb-4">
                    <div class="form-check form-switch pt-1 mb-1">
                        <div class="col-12" style="display: ruby;">
                            <label for="priorize">Priorizar</label>
                            <input type="checkbox" id="priorize" class="form-check-input"  formControlName="prioritized"/>
                        </div>
                    </div>
                </div>
                <div class="row mx-auto modal-datos-usuario-botonera">
                    <div class="col-xl-12 text-center">
                       <div class="mt-3 d-flex">
                        <button type="button" class="btn-color mx-auto" type="submit">Enviar</button>
                       </div>
                    </div>
                    <div class="col-xl-12 text-center">
                        <a type="button" (click)="cerrar()">Volver a aplicación</a>
                       </div>
                </div>
            </div>
            </form>
           
    </div>
</div>
